import { render, staticRenderFns } from "./btn-hamburger-primary.vue?vue&type=template&id=6528f5a9&scoped=true"
import script from "./btn-hamburger-primary.vue?vue&type=script&lang=js"
export * from "./btn-hamburger-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528f5a9",
  null
  
)

export default component.exports